export default __webpack_public_path__ + "static/media/Liputon-orange.2f41ebd1.svg";